define('commons/flat-tree-group',['jquery', 'commons/flat-tree', 'commons/multiselect', 'chosen'], function($, FlatTree, _) {
	
	var $groupType = $('<select multiple="multiple"></select>');
    
	$.get('/group/json/types').then(function(data) {
		for (var v in data.types) {
			$('<option></option>').attr('value', v).text(data.types[v]).appendTo($groupType);
		}
		
		$groupType.trigger('multiselect:reset');
    });
    
    var $accountFilter = $('<select name="accounts" class="account-filter" data-placeholder="Account status"><option value="">All</option><option value="true">With account only</option><option value="false">Without account only</option></select>');
	
    var FlatTreeGroup = function(containerSelector, options) {
        var self = this;
        var searchByTypeEnabled = !options.data || !(options.data.type || options.data.businessOperator || options.data.networkOperator || options.data.excludeType);
        var filterByAccountEnabled = options.filterByAccountEnabled === true;
        
        FlatTree.call(this, containerSelector, $.extend({
            loadItemUrl: '/group/json/list'
        }, options, {
        	searchThreshold: 0,
            createItem: function(item) {
                var result = options.createItem(item);
                var extraIconClassName = '';
                var extraIconTitle = '';
                
                var iconClassName = 'group ';
                
                if (result.icon) {
                    if (result.icon.className) {
                        extraIconClassName = result.icon.className + ' ';
                    }
                    if (result.icon.attrs && result.icon.attrs['title']) {
                        extraIconTitle = result.icon.attrs['title'] + ' ';
                    }
                }
                
                switch(item.type.code){
                    case 0:
                        iconClassName += 'icon-operator';
                        break;
                    case 1:
                        iconClassName += 'icon-devicemaker';
                        break;
                    case 2:
                        iconClassName += 'icon-other';
                        break;
                    case 3:
                        iconClassName += 'icon-tapmaker';
                        break;
                    case 4:
                        iconClassName += 'icon-productmaker';
                        break;
                    case 5:
                        iconClassName += 'icon-virtual';
                        break;
                    case 6:
                        iconClassName += 'icon-partners';
                        break;
                    case 7:
                        iconClassName += 'icon-nip';
                        break;
                    case 8:
                        iconClassName += 'icon-dist';
                        break;
                    case 9:
                        iconClassName += 'icon-channel';
                        break;
                    case 10:
                        iconClassName += 'icon-starter';
                        break;
                    case 11:
                        iconClassName += 'icon-partner';
                        break;
                    case 12:
                        iconClassName += 'icon-semaker';
                        break;
                    case 13:
                        iconClassName += 'icon-satellite';
                        break;    
                    
                }
                
                if (item.isAccount === true) {
                    iconClassName += ' account';
                }
                
                result.icon = {
                     className: extraIconClassName + iconClassName,
                     attrs : {
                         title : extraIconTitle + item.typeName
                     }
                };
                
                result.className ='item-group';
                return result;
            },
            additionalSearchData: function(searchValue, parentId) {
                var params = {};
            	if (searchByTypeEnabled) {
            	    params.types = ($groupType.val()||[]).join(',')
            	}
                if (filterByAccountEnabled) {
                    params.isAccount = $accountFilter.val() || '';
                }
            	
            	return params;
            },
            resetSearch: function() {
            	if (searchByTypeEnabled) {
            		$groupType.find("option:selected").removeAttr("selected").trigger('multiselect:updated');
            	}
                if (filterByAccountEnabled) {
                    $accountFilter.find("option:selected").removeAttr("selected").trigger('chosen:updated');
                }
            }
        }));
       
        if (searchByTypeEnabled) {
	        var wrapper = $('<span class="group-dialog-search-filter"></span>');
	        wrapper.append($groupType);
	        wrapper.insertAfter(this.search.$input);
	        
	        this.search.$typeFilter = wrapper;
	        
	        var searchTimeout;
	        $groupType.change(function() {
	        	clearTimeout(searchTimeout);
	        	searchTimeout = setTimeout(function() {
	            	self._search();
	        	}, self.settings.searchTimeout);
	        });
	
	        $groupType.multiselect();
        }
        
        if (filterByAccountEnabled) {
            var wrapper = $('<span class="group-dialog-search-filter"></span>');
            wrapper.append($accountFilter);
            wrapper.insertAfter(this.search.$typeFilter || this.search.$input);
            
            var accountSearchTimeout;
            $accountFilter.change(function() {
                clearTimeout(accountSearchTimeout);
                accountSearchTimeout = setTimeout(function() {
                    self._search();
                }, self.settings.searchTimeout);
            });
            
            $accountFilter.chosen({width: "175px", disable_search: true, inherit_select_classes: true});

            var downArrow = $('<span class="arrow fas fa-caret-down"></span>');
            wrapper.find('a.chosen-single').prepend(downArrow);
            
            wrapper.find('a.chosen-single div:has(b)').remove();
            
            $accountFilter.on("chosen:showing_dropdown", function () {
                downArrow.removeClass('fa-caret-down');
                downArrow.addClass('fa-caret-up');
            });
            $accountFilter.on("chosen:hiding_dropdown", function () {
                downArrow.removeClass('fa-caret-up');
                downArrow.addClass('fa-caret-down');
                downArrow.text('');
            });
            $accountFilter.on("change chosen:updated", function () { downArrow.text(''); });
        }
    };
    
    
    // Inherit from FlatTree
    for (var element in FlatTree.prototype) {
        FlatTreeGroup.prototype[element] = FlatTree.prototype[element];
    }
    
    return FlatTreeGroup;
    
});
